import { useState } from 'react'

import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'

import { SourceUploadDialogPage } from 'types/kinerja'
import Page1 from './pages/Page1'
import Page2 from './pages/Page2'
import Page3 from './pages/Page3'

import type { BuktiKaryaDocumentResponse } from 'types/bukti-karya'
import type { BuktiKaryaCategory } from 'types/kinerja'

interface SourceUploadDialogProps extends Omit<DialogProps, 'children'> {
  onChange?: (file: File | BuktiKaryaDocumentResponse) => void
}

export default function SourceUploadDialog({
  onChange = () => {},
  onClose = () => {},
  ...props
}: SourceUploadDialogProps) {
  const [page, setPage] = useState(SourceUploadDialogPage.HOME)
  const [category, setCategory] = useState<BuktiKaryaCategory | null>(null)

  const handleClose = () => {
    // reset page state
    setPage(SourceUploadDialogPage.HOME)
    setCategory(null)

    // close dialog
    onClose()
  }

  return (
    <Dialog size="md" onClose={handleClose} {...props}>
      <DialogOverlay />

      <DialogContent>
        <div className="p-9 flex flex-col gap-9">
          <DialogCloseButton
            data-testid="btn-close"
            style={{ top: '36px', right: '36px' }}
          />
          {page === SourceUploadDialogPage.HOME && (
            <Page1
              onChange={onChange}
              onClose={handleClose}
              onSetPage={setPage}
            />
          )}

          {page === SourceUploadDialogPage.BUKTI_KARYA_CATEGORIES && (
            <Page2
              onSetPage={(page, param) => {
                setCategory(param)
                setPage(page)
              }}
            />
          )}

          {page === SourceUploadDialogPage.BUKTI_KARYA_DOCUMENT_LIST && (
            <Page3
              selectedCategory={category}
              onChange={onChange}
              onClose={handleClose}
              onSetPage={setPage}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
